import { render } from "./SecurityTab.vue?vue&type=template&id=4a3c4db5&scoped=true"
import script from "./SecurityTab.vue?vue&type=script&lang=js"
export * from "./SecurityTab.vue?vue&type=script&lang=js"

import "./SecurityTab.vue?vue&type=style&index=0&id=4a3c4db5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3c4db5"]])

export default __exports__